const TIME_ZONE = 'Europe/Copenhagen';

function parts(iso: string, options: Intl.DateTimeFormatOptions): Intl.DateTimeFormatPart[] | null {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return new Intl.DateTimeFormat('en-GB', {
    timeZone: TIME_ZONE,
    hourCycle: 'h23',
    ...options,
  }).formatToParts(date);
}

function pick(list: Intl.DateTimeFormatPart[], type: Intl.DateTimeFormatPartTypes): string {
  return list.find((part) => part.type === type)?.value ?? '';
}

/** dd-mm-åååå in Europe/Copenhagen. */
export function formatCopenhagenDate(iso: string): string {
  const list = parts(iso, { day: '2-digit', month: '2-digit', year: 'numeric' });
  if (!list) return '—';
  return `${pick(list, 'day')}-${pick(list, 'month')}-${pick(list, 'year')}`;
}

/** HH:MM in Europe/Copenhagen. */
export function formatCopenhagenTime(iso: string): string {
  const list = parts(iso, { hour: '2-digit', minute: '2-digit' });
  if (!list) return '—';
  return `${pick(list, 'hour')}:${pick(list, 'minute')}`;
}

/** dd-mm-åååå kl. HH:MM in Europe/Copenhagen. */
export function formatCopenhagenDateTime(iso: string): string {
  const list = parts(iso, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
  if (!list) return '—';
  return `${pick(list, 'day')}-${pick(list, 'month')}-${pick(list, 'year')} kl. ${pick(list, 'hour')}:${pick(list, 'minute')}`;
}
